(() => {
  const initFilters = () => {
    document.querySelectorAll('[data-an-option-filters]').forEach(panel => {
      if (panel.dataset.ready) return;
      const scope = panel.closest('collection-component');
      const cards = [...(scope?.querySelectorAll('[data-an-filter-card]') || [])];
      if (!cards.length) return;
      panel.dataset.ready = 'true';
      const sizeSelect = panel.querySelector('[data-an-size]');
      const colorSelect = panel.querySelector('[data-an-color]');
      const sizes = new Set();
      const colors = new Set();
      const data = cards.map(card => {
        let names = [], variants = [];
        try { names = JSON.parse(card.dataset.anOptions); variants = JSON.parse(card.dataset.anVariants); } catch { return { card, variants: [], size: -1, color: -1 }; }
        const size = names.findIndex(n => /^(talla|size)$/i.test(String(n).trim()));
        const color = names.findIndex(n => /^(color|colour)$/i.test(String(n).trim()));
        variants.filter(v => v.available).forEach(v => {
          if (size >= 0) sizes.add(v.options[size]);
          if (color >= 0) colors.add(v.options[color]);
        });
        return { card, variants, size, color };
      });
      const sizeOrder = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL','6XL'];
      [...sizes].sort((a,b) => {
        const ai=sizeOrder.indexOf(a), bi=sizeOrder.indexOf(b);
        return ai>=0 && bi>=0 ? ai-bi : a.localeCompare(b,'es',{numeric:true});
      }).forEach(v => sizeSelect.add(new Option(v,v)));
      [...colors].sort((a,b)=>a.localeCompare(b,'es')).forEach(v=>colorSelect.add(new Option(v,v)));
      panel.querySelector('[data-an-size-field]').hidden = !sizes.size;
      panel.querySelector('[data-an-color-field]').hidden = !colors.size;
      panel.hidden = false;
      const sortSelect = panel.querySelector('[data-an-sort]');
      const grid = cards[0].parentElement;
      const sortCards = () => {
        const sorted = [...cards];
        if (sortSelect.value === 'price-ascending') sorted.sort((a,b)=>Number(a.dataset.anPrice)-Number(b.dataset.anPrice));
        if (sortSelect.value === 'price-descending') sorted.sort((a,b)=>Number(b.dataset.anPrice)-Number(a.dataset.anPrice));
        if (sortSelect.value === 'title-ascending') sorted.sort((a,b)=>a.dataset.anTitle.localeCompare(b.dataset.anTitle,'es'));
        sorted.forEach(card=>grid.append(card));
      };
      sortSelect?.addEventListener('change',sortCards);
      const apply = () => {
        let count = 0;
        const matchingSizes = new Set();
        const matchingColors = new Set();
        data.forEach(({card,variants,size,color}) => {
          variants.filter(v => v.available).forEach(v => {
            if (size >= 0 && (!colorSelect.value || color >= 0 && v.options[color] === colorSelect.value)) matchingSizes.add(v.options[size]);
            if (color >= 0 && (!sizeSelect.value || size >= 0 && v.options[size] === sizeSelect.value)) matchingColors.add(v.options[color]);
          });
          const matches = (!sizeSelect.value && !colorSelect.value) || variants.some(v => v.available && (!sizeSelect.value || size>=0 && v.options[size]===sizeSelect.value) && (!colorSelect.value || color>=0 && v.options[color]===colorSelect.value));
          card.hidden = !matches;
          if(matches) count++;
        });
        Array.from(sizeSelect.options).forEach(option => { option.disabled = !!option.value && !matchingSizes.has(option.value); });
        Array.from(colorSelect.options).forEach(option => { option.disabled = !!option.value && !matchingColors.has(option.value); });
        panel.querySelector('[data-an-count]').textContent=count===1?panel.dataset.singleLabel:panel.dataset.countLabel.replace('__COUNT__',count);
        panel.querySelector('[data-an-empty]').hidden=count>0;
        panel.querySelector('[data-an-clear]').hidden=!sizeSelect.value && !colorSelect.value;
      };
      sizeSelect.addEventListener('change',apply);colorSelect.addEventListener('change',apply);
      panel.querySelector('[data-an-clear]').addEventListener('click',()=>{sizeSelect.value='';colorSelect.value='';apply();});
      apply();
    });
    document.querySelectorAll('select[name="sort_by"] option[value="manual"]').forEach(option=>{option.textContent='Recomendados';});
  };
  initFilters();
  const gridObserver = new MutationObserver(records => {
    if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('collection-component,[data-an-option-filters],#ProductGridContainer')||n.querySelector?.('[data-an-option-filters]'))))) initFilters();
  });
  gridObserver.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  const cartStyle = `
.upcart-cart .upcart-public-component-product-tile__price,.upcart-cart .upcart-public-component-product-tile__price span{color:#b12828!important}

.an-cart-brand{display:flex;align-items:center;justify-content:center;gap:10px}.an-cart-brand img{width:38px!important;height:38px!important;object-fit:contain}.an-cart-brand .an-cart-wordmark{font-family:Jost,Arial,sans-serif!important;font-size:20px!important;font-weight:400!important;letter-spacing:.14em!important;color:#382820}.an-cart-tier__labels{position:relative;display:grid!important;grid-template-columns:repeat(3,1fr)!important;gap:8px!important;text-align:center}.an-cart-tier__labels span{position:relative;padding-bottom:9px;color:#8d7d72}.an-cart-tier__labels span::after{content:'';display:block;position:absolute;bottom:-8px;left:calc(50% - 3px);height:6px;width:6px;border-radius:50%;background:#ddcec2;z-index:1}.an-cart-tier__labels span.is-reached{color:#87472f;font-weight:600}.an-cart-tier__labels span.is-reached::after{background:#87472f}.an-cart-tier__bar{margin:3px 0 9px!important}.an-cart-tier p{text-align:center}.upcart-cart-body .an-autumn-progress{padding-top:10px!important}.upcart-public-component-product-tile__price,.upcart-public-component-product-tile__price span,.upcart-public-component-product-tile__price-price{color:#b12828!important}

.upcart-cart-body .an-autumn-progress{display:block!important;padding:0 16px!important;box-sizing:border-box;width:100%}

.an-autumn-progress{background:transparent!important;padding:0!important;border:0!important;margin:0 0 12px!important}.an-cart-tier{padding:10px 0 12px;border-bottom:1px solid #e8ddd4;color:#6b4b3b}.an-cart-tier__labels{display:flex;justify-content:space-between;gap:6px;font-size:11px;line-height:1.4}.an-cart-tier__bar{height:3px;background:#e9dfd6;border-radius:4px;overflow:hidden;margin:8px 0}.an-cart-tier__bar span{height:100%;display:block;background:#87472f;border-radius:4px}.an-cart-tier p{font-size:11px!important;line-height:1.4;margin:0!important}.an-cart-wordmark{font-family:Georgia,serif;font-size:25px;letter-spacing:.06em;color:#382820;white-space:nowrap}.upcart-public-product-title,.upcart-public-component-product-tile__title-link{text-transform:uppercase!important}.an-cart-payments ul{display:flex;justify-content:center;list-style:none;padding:0;gap:5px;margin:10px 0}.an-cart-payments svg{width:30px;height:20px}.an-cart-payments .visually-hidden{display:none}.upcart-public-component-product-tile__price{color:#436245!important}

.an-autumn-progress{background:#faf8f4;border:1px solid #e6e0d7;padding:14px;color:#302b26}.an-autumn-progress>strong{font-size:14px;font-weight:500}.an-autumn-progress ul{list-style:none;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin:10px 0;padding:0}.an-autumn-progress li{border:1px solid #e6e0d7;padding:8px 3px;font-size:11px;text-align:center;line-height:1.4}.an-autumn-progress li b{display:block;font-size:16px}.an-autumn-progress li.is-current{background:#34483d;color:#fff;border-color:#34483d}.an-autumn-progress p{font-size:12px;line-height:1.5;margin:8px 0}.an-autumn-progress small{display:block;font-size:10px;line-height:1.5}

    .upcart-cart-body{justify-content:flex-start!important;gap:18px!important}
    .styles_CartPreview__bottomModules__{margin-top:16px!important;padding-top:0!important}
    .upcart-public-header{padding-top:18px!important;padding-bottom:18px!important}
    .upcart-public-header h4{color:#241f1b!important;font-size:20px!important;letter-spacing:.08em!important;text-transform:uppercase!important}
    .upcart-public-cart{background:#fff!important}
    .upcart-public-product-title,.upcart-public-component-product-tile__title-link{font-weight:500!important;line-height:1.4!important;color:#25211e!important;font-size:14px!important;letter-spacing:.025em!important}
    .upcart-public-component-product-tile__savings{color:#71685f!important;font-weight:400!important;font-size:11px!important}
    .upcart-public-product-image{border-radius:0!important}
    .upcart-public-header{border-bottom:1px solid #e5dfd8!important}
    .upcart-checkout-button{background:#87472f!important;color:#fff!important;border-radius:0!important;min-height:56px!important;letter-spacing:.09em!important;text-transform:uppercase!important}
    [data-upcart-chunk="announcement"]{display:none!important}
    .an-cart-assurance{font-size:12px;line-height:1.45;color:#49413b;margin:8px 0 12px}
    .an-cart-assurance p{margin:4px 0}
    .an-cart-assurance__shipping{display:inline-flex;align-items:center;min-height:44px}
    .upcart-public-component-product-tile__quantity-minus,.upcart-public-component-product-tile__quantity-plus{min-width:44px!important;min-height:44px!important}
    .upcart-public-component-product-tile__remove-button{min-width:44px!important;min-height:44px!important}
    a:focus-visible,button:focus-visible,input:focus-visible,summary:focus-visible{outline:2px solid #34483d!important;outline-offset:2px!important}
    .upcart-footer{padding-bottom:max(12px,env(safe-area-inset-bottom))!important}
    .an-cart-assurance a{color:inherit;text-underline-offset:2px}
    .an-cart-assurance summary{cursor:pointer;min-height:44px;display:flex;align-items:center;gap:8px}
    .an-cart-assurance summary::after{content:'+';margin-left:auto;font-size:18px}
    .an-cart-assurance details[open] summary::after{content:'−'}
    @media(max-width:749px){
      .upcart-public-header{padding-top:12px!important;padding-bottom:12px!important}
      .upcart-cart-body{gap:10px!important}
      .an-cart-assurance{font-size:12px;line-height:1.4;margin:0 0 6px}
      .an-cart-assurance p{margin:2px 0}
      .upcart-footer{padding:10px 16px max(10px,env(safe-area-inset-bottom))!important}
      .upcart-checkout-button{min-height:48px!important}
    }

.an-cart-brand .an-cart-wordmark{font-family:Georgia,"Times New Roman",serif!important;font-size:24px!important;letter-spacing:.06em!important;color:#111!important}.an-cart-tier{padding:14px 0 20px!important;border:0!important;color:#111!important}.an-cart-tier__labels{display:none!important}.an-cart-tier .an-cart-tier__message{font-size:13px!important;line-height:1.5!important;text-align:center!important;margin:0 auto 16px!important;max-width:280px!important;color:#111!important}.an-cart-tier__bar{height:5px!important;background:#e7e7e7!important;margin:0!important;border-radius:3px!important}.an-cart-tier__bar span{background:#111!important;transition:width .25s}.an-cart-tier-page{margin-bottom:22px}.upcart-public-product-title,.upcart-public-component-product-tile__title-link{text-transform:none!important;letter-spacing:0!important}.an-cart-brand img{display:none!important}.upcart-cart .upcart-public-component-product-tile__price,.upcart-cart .upcart-public-component-product-tile__price span{color:#b12828!important}.upcart-public-component-product-tile__price s,.upcart-public-component-product-tile__price del{color:#111!important}
  `;
  let attachedRoot;
  let progressSignature = '';
  let progressTimer;
  let progressRequest;
  const refreshAutumnProgress = (body, signature) => {
    clearTimeout(progressTimer);
    progressRequest?.abort();
    progressTimer = setTimeout(async () => {
      const controller = new AbortController();
      progressRequest = controller;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + '?section_id=an-autumn-progress', {cache: 'no-store', signal: controller.signal});
        if (!response.ok) return;
        const html = await response.text();
        if (signature !== progressSignature || !body.isConnected) return;
        const template = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-an-autumn-progress-content]');
        const content = template?.content.querySelector('.an-autumn-progress');
        const previous = body.querySelector('.an-autumn-progress');
        if (!content) {previous?.remove();return;}
        if (previous) previous.replaceWith(content);
        else body.prepend(content);
      } catch (error) {
        if (error.name !== 'AbortError') progressSignature = '';
      }
    }, 250);
  };
  const mountCart = () => {
    const root=document.querySelector('#upCart')?.shadowRoot;
    if(!root) return;
    if(root!==attachedRoot){attachedRoot=root;new MutationObserver(scheduleCart).observe(root,{childList:true,subtree:true});}
    if(!root.querySelector('[data-an-cart-style]')){const style=document.createElement('style');style.dataset.anCartStyle='';style.textContent=cartStyle;root.append(style);}
    const header = root.querySelector('.upcart-public-header');
    const brandTemplate = document.querySelector('[data-an-cart-brand]');
    if (header && brandTemplate && !header.querySelector('.an-cart-brand')) {
      header.querySelector('img')?.remove(); header.querySelector('.an-cart-wordmark')?.remove();
      header.prepend(brandTemplate.content.cloneNode(true));
    }
    root.querySelectorAll('.upcart-public-product-title,.upcart-public-component-product-tile__title-link').forEach(link => { const title = link.textContent.replace(/ · | — | – /g, ' | '); if (title !== link.textContent) link.textContent = title; });
    const items=[...root.querySelectorAll('.upcart-public-cart-item')];
    const body=root.querySelector('.upcart-cart-body');
    const footer=root.querySelector('.upcart-footer');
    if(!body||!footer) return;
    const paymentTemplate = document.querySelector('[data-an-cart-payments]');
    const paymentImage = footer.querySelector('img');
    if (!footer.querySelector('.an-cart-payments') && paymentTemplate) {
      const paymentStrip = document.createElement('div'); paymentStrip.className = 'an-cart-payments';
      paymentStrip.append(paymentTemplate.content.cloneNode(true)); if (paymentImage) paymentImage.replaceWith(paymentStrip); else footer.append(paymentStrip);
    }

    const tpl=document.querySelector('[data-an-cart-assurance]');
    if(tpl){
      const labels=tpl.dataset;
      const translations={'Close cart':labels.close,'Increase quantity':labels.increase,'Decrease quantity':labels.decrease,'Product quantity':labels.quantity,'Remove tag':labels.removeDiscount,'Previous slide':labels.previous,'Next slide':labels.next};
      root.querySelectorAll('[aria-label]').forEach(control=>{
        const current=control.getAttribute('aria-label');
        const translated=translations[current];
        if(translated && translated!==current) control.setAttribute('aria-label',translated);
        else if(document.documentElement.lang.startsWith('es') && current.startsWith('Remove ') && current!=='Remove tag') control.setAttribute('aria-label',labels.remove+' '+current.slice(7));
      });
    }
    const assurance=footer.querySelector('.an-cart-assurance');
    if(!items.length){
      assurance?.remove();body.querySelector('.an-autumn-progress')?.remove();
      progressSignature='';clearTimeout(progressTimer);progressRequest?.abort();return;
    }
    const signature = items.map(item => item.textContent + [...item.querySelectorAll('input')].map(input => input.value).join(':')).join('|');
    if(signature !== progressSignature){progressSignature=signature;refreshAutumnProgress(body,signature);}
    if(!assurance && tpl) footer.prepend(tpl.content.cloneNode(true));
  };
  let scheduled=false;
  function scheduleCart(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;mountCart();});}
  new MutationObserver(scheduleCart).observe(document.body,{childList:true,subtree:false});
  document.addEventListener('click',scheduleCart);scheduleCart();
})();



(() => {
  const template = document.querySelector('template[data-an-color-photographs]');
  if (!template) return;
  const photos = new Map([...template.content.querySelectorAll('[data-color]')].map(item => [item.dataset.color, item.dataset.image]));
  if (!photos.size) return;
  let queued = false;
  const enhance = () => {
    queued = false;
    document.querySelectorAll('.product__info-container .swatch-view-item[role="radio"]').forEach(item => {
      const name = item.getAttribute('orig-value');
      const image = photos.get(name);
      const target = item.querySelector('.star-set-image');
      if (!image || !target) return;
      item.classList.add('an-photo-option');
      const background = `url("${image}")`;
      if (target.style.backgroundImage !== background) target.style.setProperty('background-image', background, 'important');
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(enhance); } };
  enhance();
  const root = document.querySelector('product-info');
  if (root) new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', schedule);
})();




